import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

export const TextInputBody = ({ className, placeholder, ...props }) => {
    return (
        <input
            {...props}
            className={className}
            type="text"
            placeholder={placeholder}
        />
    );
};

const TextInput = styled(TextInputBody)``;

TextInput.propTypes = {
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    type: PropTypes.string,
    value: PropTypes.string,
    checked: PropTypes.bool,
    multiple: PropTypes.bool
};

export { TextInput };
